<script>
import TablePage from '@/found/components/table_page';

export default {
  extends: TablePage,
  data() {
    return {
      formConfig: {},
    };
  },
  props: {
    propsObj: Object,
  },
  mounted() {
    this.params = { activityId: this.propsObj.row.activityId, businessId: this.propsObj.row.id };
    this.getConfigList('scan_details');
  },
  methods: {

  },
};
</script>
